export const nonItServicesData = [
  // ======================================================
  // 1. BUSINESS & STRATEGY CONSULTING
  // ======================================================
  {
    categoryId: "business-strategy-consulting",
    categoryTitle: "Business & Strategy Consulting",
    categoryDescription:
      "Strategic advisory services to optimize operations, efficiency, and long-term growth.",
    services: [
      {
        id: "business-process-optimization",
        title: "Business Process Optimization",
        shortValue:
          "Streamlining operations to improve efficiency and reduce costs.",
        pagePath: "/nonitservices/business-process",
        heroImage: "/nonitservices/bpohero.jpg",
        overviewImage: "/nonitservices/bpoover.jpg",
        overview: `
We analyze and optimize business processes to eliminate inefficiencies, reduce operational costs, and improve overall productivity. Our approach focuses on aligning workflows with business objectives while maintaining quality and compliance.

By redesigning processes and introducing best practices, we help organizations operate faster, smarter, and more efficiently.
        `,
        capabilities: [
          "Process Mapping & Analysis",
          "Workflow Optimization",
          "Cost Reduction Strategies",
          "Performance Measurement",
          "Continuous Improvement"
        ],
        tools: ["lean", "six-sigma", "powerbi"],
        outcomes: [
          "Improved operational efficiency",
          "Reduced operational costs",
          "Faster turnaround times"
        ],
        industries: ["Manufacturing", "Retail", "Services"]
      },

      {
  id: "nonit-staff-augmentation",
  title: "Non-IT Staff Augmentation",
  shortValue:
    "Flexible workforce solutions for non-technical roles.",
  pagePath: "/nonitservices/nonit-staff-augmentation",
  heroImage: "/nonitservices/nsahero.jpg",
  overviewImage: "/nonitservices/nsaover.jpg",
  overview: ` 
We provide skilled non-IT professionals to support your business operations across various functions. Our staff augmentation services help you scale teams quickly while maintaining productivity and operational efficiency.

We work as an extended workforce for your organization.
        `,
  capabilities: [
    "Administrative Staffing",
    "HR & Payroll Support",
    "Finance & Accounting Resources",
    "Customer Support & Operations",
    "Sales & Back-Office Support"
  ],
  tools: ["zoho-people", "sap", "workday", "ms-excel"],
  outcomes: [
    "Quick access to skilled professionals",
    "Operational scalability"
  ],
  industries: ["SMEs", "Enterprise"]
}
,
      {
        id: "digital-transformation-consulting",
        title: "Digital Transformation Consulting",
        shortValue:
          "Guiding businesses through digital change initiatives.",
        pagePath: "/nonitservices/digital-transformation",
        heroImage: "/nonitservices/dgchero.jpg",
        overviewImage: "/nonitservices/dgcover.jpg",
        overview: `
We help organizations adopt digital technologies to transform business models, customer experiences, and internal operations. Our consulting ensures technology adoption aligns with strategic goals.

From planning to execution, we support organizations at every stage of their digital journey.
        `,
        capabilities: [
          "Digital Strategy Roadmapping",
          "Technology Assessment",
          "Change Management",
          "Process Digitization",
          "Transformation Governance"
        ],
        tools: ["powerbi", "jira", "microsoft365"],
        outcomes: [
          "Improved digital maturity",
          "Increased competitiveness",
          "Sustainable growth"
        ],
        industries: ["Enterprise", "SMEs", "Startups"]
      },

      {
        id: "operational-efficiency-consulting",
        title: "Operational Efficiency Consulting",
        shortValue:
          "Improving productivity and resource utilization.",
        pagePath: "/nonitservices/operationalefficiency",
        heroImage: "/nonitservices/ochero.jpg",
        overviewImage: "/nonitservices/ocover.jpg",
        overview: `
We assess operational structures to identify gaps in productivity, resource allocation, and performance. Our consulting focuses on improving efficiency without compromising quality.

We help organizations achieve operational excellence through structured improvements and measurable results.
        `,
        capabilities: [
          "Operational Assessment",
          "KPI Framework Design",
          "Resource Optimization",
          "Risk Reduction",
          "Performance Benchmarking"
        ],
        tools: ["excel", "powerbi"],
        outcomes: [
          "Higher productivity",
          "Optimized resource usage"
        ],
        industries: ["Logistics", "Manufacturing", "Healthcare"]
      }
    ]
  },

  // ======================================================
  // 2. BRANDING & CREATIVE SERVICES
  // ======================================================
  {
    categoryId: "branding-creative-services",
    categoryTitle: "Branding & Creative Services",
    categoryDescription:
      "Creative solutions that strengthen brand identity and market presence.",
    services: [
      {
        id: "brand-identity-design",
        title: "Brand Identity Design",
        shortValue:
          "Building strong, consistent, and memorable brand identities.",
        pagePath: "/nonitservices/brandidentity",
        heroImage: "/nonitservices/bdhero.jpg",
        overviewImage: "/nonitservices/bdover.jpg",
        overview: `
We create distinctive brand identities that communicate your values, vision, and positioning clearly. Our designs ensure consistency across all brand touchpoints.

From logos to brand guidelines, we craft identities that build trust and recognition.
        `,
        capabilities: [
          "Logo Design",
          "Brand Guidelines",
          "Visual Identity Systems",
          "Typography & Color Systems",
          "Brand Positioning"
        ],
        tools: ["figma", "adobe-illustrator", "photoshop"],
        outcomes: [
          "Stronger brand recognition",
          "Consistent brand messaging"
        ],
        industries: ["Startups", "Retail", "Technology"]
      },

      {
        id: "ui-ux-design",
        title: "UI/UX Design",
        shortValue:
          "User-centered design for digital experiences.",
        pagePath: "/nonitservices/uiuxdesign",
        heroImage: "/nonitservices/uiuxhero.jpg",
        overviewImage: "/nonitservices/uiuxover.jpg",
        overview: `
We design intuitive and engaging user experiences that improve usability and satisfaction. Our UI/UX approach is grounded in research, usability testing, and modern design principles.

The result is digital products that users love to interact with.
        `,
        capabilities: [
          "User Research",
          "Wireframing & Prototyping",
          "Interaction Design",
          "Usability Testing",
          "Design Systems"
        ],
        tools: ["figma", "adobe-xd"],
        outcomes: [
          "Improved user satisfaction",
          "Higher engagement rates"
        ],
        industries: ["SaaS", "E-commerce", "Enterprise"]
      },

      {
        id: "creative-assets-marketing-design",
        title: "Creative Assets & Marketing Design",
        shortValue:
          "Visually compelling assets for marketing campaigns.",
        pagePath: "/nonitservices/creative-assets",
        heroImage: "/nonitservices/cahero.jpg",
        overviewImage: "/nonitservices/caover.jpg",
        overview: `
We design high-impact marketing creatives that support campaigns across digital and offline channels. Our assets are crafted to attract attention and communicate value.

From ads to presentations, we ensure brand consistency and visual appeal.
        `,
        capabilities: [
          "Marketing Collaterals",
          "Social Media Creatives",
          "Presentation Design",
          "Campaign Visuals",
          "Print Design"
        ],
        tools: ["photoshop", "illustrator", "canva"],
        outcomes: [
          "Improved campaign performance",
          "Stronger brand recall"
        ],
        industries: ["Marketing", "Retail"]
      },

      {
        id: "website-corporate-content",
        title: "Website & Corporate Content",
        shortValue:
          "Professional content for digital and corporate platforms.",
        pagePath: "/nonitservices/website-content-services",
        heroImage: "/nonitservices/wchero.jpg",
        overviewImage: "/nonitservices/wcover.jpg",
        overview: `
We create clear, engaging, and professional content tailored for websites and corporate communication. Our content supports brand messaging and business objectives.

Designed to improve clarity, credibility, and engagement.
        `,
        capabilities: [
          "Website Content Writing",
          "Corporate Profiles",
          "Pitch Deck Content",
          "Company Documentation",
          "Brand Messaging"
        ],
        tools: ["google-docs", "notion"],
        outcomes: [
          "Clear brand communication",
          "Improved audience engagement"
        ],
        industries: ["Corporate", "Startups"]
      },
      {
  id: "content-management-support",
  title: "Content Management Support",
  shortValue:
    "Efficient content management and digital upkeep.",
  pagePath: "/nonitservices/content-management",
  heroImage: "/nonitservices/cmhero.jpg",
  overviewImage: "/nonitservices/cmover.jpg",
  overview: ` 
We manage, update, and optimize digital content across websites and platforms to ensure consistency, accuracy, and engagement. Our support helps businesses maintain a strong and up-to-date digital presence.

We work as an extended content operations team for your organization.
        `,
  capabilities: [
    "Website Content Updates",
    "Content Publishing & Scheduling",
    "Content Quality & Consistency Checks",
    "CMS Administration",
    "Content Performance Monitoring"
  ],
  tools: ["wordpress", "drupal", "joomla", "contentful"],
  outcomes: [
    "Consistent and updated content",
    "Improved user engagement"
  ],
  industries: ["SMEs", "Enterprise"]
}

    ]
  },

  // ======================================================
  // 3. ACCOUNTING & FINANCIAL OPERATIONS
  // ======================================================
  {
    categoryId: "accounting-financial-operations",
    categoryTitle: "Accounting & Financial Operations",
    categoryDescription:
      "Reliable financial management and operational accounting services.",
    services: [
      {
        id: "accounting-management",
        title: "Accounting Management",
        shortValue:
          "End-to-end accounting and financial control.",
        pagePath: "/nonitservices/accounting-management",
        heroImage: "/nonitservices/amhero.jpg",
        overviewImage: "/nonitservices/amover.jpg",
        overview: ` 
We manage accounting operations to ensure accuracy, compliance, and financial transparency. Our services support informed decision-making and financial stability.

We work as an extended finance team for your organization.
        `,
        capabilities: [
          "General Accounting",
          "Financial Controls",
          "Compliance Management",
          "Reconciliations",
          "Audit Support"
        ],
        tools: ["tally", "zoho-books", "quickbooks"],
        outcomes: [
          "Accurate financial records",
          "Regulatory compliance"
        ],
        industries: ["SMEs", "Enterprise"]
      },

      {
        id: "bookkeeping-ledger-handling",
        title: "Bookkeeping & Ledger Handling",
        shortValue:
          "Accurate and organized financial records.",
        pagePath: "/nonitservices/bookkeeping-services",
        heroImage: "/nonitservices/bkhero.jpg",
        overviewImage: "/nonitservices/bkover.jpg",
        overview: `
We maintain detailed and accurate bookkeeping records to support financial reporting and audits. Our structured approach ensures transparency and consistency.

Ideal for businesses seeking reliable financial record management.
        `,
        capabilities: [
          "Ledger Maintenance",
          "Transaction Recording",
          "Reconciliation",
          "Expense Tracking",
          "Documentation Management"
        ],
        tools: ["tally", "excel"],
        outcomes: [
          "Organized financial data",
          "Reduced accounting errors"
        ],
        industries: ["SMEs", "Startups"]
      },

      {
        id: "financial-reporting",
        title: "Financial Reporting",
        shortValue:
          "Clear and compliant financial reporting services.",
        pagePath: "/nonitservices/financial-reporting",
        heroImage: "/nonitservices/finhero.jpg",
        overviewImage: "/nonitservices/finover.jpg",
        overview: `
We prepare accurate financial reports that provide insight into business performance. Our reports support strategic planning and compliance requirements.

Designed for clarity, accuracy, and decision-making.
        `,
        capabilities: [
          "Monthly & Annual Reports",
          "Profit & Loss Statements",
          "Cash Flow Reports",
          "Compliance Reporting",
          "Management Dashboards"
        ],
        tools: ["excel", "powerbi"],
        outcomes: [
          "Better financial visibility",
          "Informed decision-making"
        ],
        industries: ["Corporate", "Finance"]
      },

      {
        id: "financial-operations-support",
        title: "Financial Operations Support",
        shortValue:
          "Operational finance support for growing businesses.",
        pagePath: "/nonitservices/financial-operations",
        heroImage: "/nonitservices/finophero.jpg",
        overviewImage: "/nonitservices/finopover.jpg",
        overview: `
We support day-to-day financial operations, ensuring smooth execution of accounting and finance activities. Our services reduce operational burden and improve accuracy.

Designed to support scalability and business growth.
        `,
        capabilities: [
          "Operational Finance Support",
          "Process Coordination",
          "Vendor Payments",
          "Compliance Assistance",
          "Reporting Support"
        ],
        tools: ["zoho-books", "quickbooks"],
        outcomes: [
          "Smooth financial operations",
          "Reduced internal workload"
        ],
        industries: ["SMEs", "Enterprises"]
      }
    ]
  },

  // ======================================================
  // 4. DIGITAL MARKETING SERVICES
  // ======================================================
  {
    categoryId: "digital-marketing-services",
    categoryTitle: "Digital Marketing Services",
    categoryDescription:
      "Performance-driven digital marketing and growth strategies.",
    services: [
      {
        id: "seo-services",
        title: "SEO Services",
        shortValue:
          "Search engine optimization for long-term visibility.",
        pagePath: "/nonitservices/seo-services",
        heroImage: "/nonitservices/seohero.jpg",
        overviewImage: "/nonitservices/seoover.jpg",
        overview: `
We improve organic search visibility through technical SEO, content optimization, and authority building. Our SEO strategies focus on sustainable growth.

Designed to drive consistent, high-quality traffic.
        `,
        capabilities: [
          "Technical SEO",
          "On-Page Optimization",
          "Keyword Research",
          "Content Optimization",
          "SEO Reporting"
        ],
        tools: ["ahrefs", "semrush", "google-search-console"],
        outcomes: [
          "Improved search rankings",
          "Increased organic traffic"
        ],
        industries: ["E-commerce", "SaaS"]
      },

      {
        id: "performance-marketing",
        title: "Performance Marketing (Google & Meta Ads)",
        shortValue:
          "ROI-focused paid advertising campaigns.",
        pagePath: "/nonitservices/performance-marketing",
        heroImage: "/nonitservices/perhero.jpg",
        overviewImage: "/nonitservices/perover.jpg",
        overview: `
We manage performance-driven ad campaigns across Google and Meta platforms. Our approach focuses on ROI, conversions, and scalable growth.

We continuously optimize campaigns to maximize returns.
        `,
        capabilities: [
          "Google Ads Management",
          "Meta Ads Campaigns",
          "Audience Targeting",
          "Conversion Tracking",
          "Campaign Optimization"
        ],
        tools: ["google-ads", "meta-ads", "analytics"],
        outcomes: [
          "Higher conversion rates",
          "Improved ad ROI"
        ],
        industries: ["Retail", "Startups"]
      },

      {
        id: "social-media-management",
        title: "Social Media Management",
        shortValue:
          "Consistent and engaging social media presence.",
        pagePath: "/nonitservices/social-media-management",
        heroImage: "/nonitservices/smhero.jpg",
        overviewImage: "/nonitservices/smover.jpg",
        overview: `
We manage social media channels to build brand awareness and engagement. Our strategies focus on content consistency and audience growth.

Designed to strengthen digital presence.
        `,
        capabilities: [
          "Content Planning",
          "Post Scheduling",
          "Community Management",
          "Analytics & Reporting",
          "Brand Voice Management"
        ],
        tools: ["hootsuite", "buffer", "meta-business-suite"],
        outcomes: [
          "Higher engagement",
          "Improved brand visibility"
        ],
        industries: ["Brands", "Startups"]
      },

      {
        id: "lead-generation-campaigns",
        title: "Lead Generation Campaigns",
        shortValue:
          "Targeted campaigns to generate qualified leads.",
        pagePath: "/nonitservices/lead-generation",
        heroImage: "/nonitservices/lghero.jpg",
        overviewImage: "/nonitservices/lgover.jpg",
        overview: `
We design and execute lead generation campaigns that attract high-quality prospects. Our campaigns are data-driven and conversion-focused.

Designed to support sales growth.
        `,
        capabilities: [
          "Audience Targeting",
          "Landing Page Strategy",
          "Lead Funnels",
          "Campaign Analytics",
          "Optimization"
        ],
        tools: ["google-ads", "meta-ads", "crm-tools"],
        outcomes: [
          "Increased qualified leads",
          "Improved sales pipeline"
        ],
        industries: ["B2B", "B2C"]
      }
    ]
  }
];
